import { Upload } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import React, { ChangeEvent } from "react";
import { SystemModuleLicense } from "../../api/api-generated";
import { TrimmedCompany } from "../../api/api-types";
import { Optional } from "./SystemModulesDialog";

interface Props {
  company: TrimmedCompany;
  setSelectedSystemModules: React.Dispatch<
    React.SetStateAction<
      (Optional<SystemModuleLicense, "id" | "company" | "orderId"> | null)[]
    >
  >;
}

const ImportButton = ({ company, setSelectedSystemModules }: Props) => {
  const handleUploadLicense = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target?.result;
      if (!text || typeof text !== "string") return;
      const item = JSON.parse(text);
      if (!("modules" in item) || !("iv" in item)) return;
      const newSelectedSystemModules: (Optional<
        SystemModuleLicense,
        "id" | "company" | "orderId"
      > | null)[] = [];
      for (const moduleItem of Object.keys(item.modules)) {
        newSelectedSystemModules.push({
          module: moduleItem,
          license: item.modules[moduleItem],
          iv: item.iv,
          companyId: company.id,
        });
      }
      setSelectedSystemModules(newSelectedSystemModules);
    };
    reader.readAsText(file);
  };
  return (
    <Grid item>
      <input
        style={{ display: "none" }}
        id="outlined-button-file"
        type="file"
        accept=".lic"
        onChange={handleUploadLicense}
      />
      <label htmlFor="outlined-button-file">
        <IconButton color="primary" component="span">
          <Upload />
        </IconButton>
      </label>
    </Grid>
  );
};

export default ImportButton;
